import { useEffect } from 'react';
import { useProductName } from '@atlassian/jira-tenant-context-controller/src/components/product-name/index.tsx';
import useIsAdminHubAIEnabled from '@atlassian/jira-platform-react-hooks-use-is-admin-hub-ai-enabled/src/controllers/index.tsx';
import { getProductForAdminHubAi } from './utils.tsx';

export const useIsAiEnabledBacklog = (): boolean => {
	const productName = useProductName();
	const adminHubAiProductName = getProductForAdminHubAi(productName);
	const {
		data: isAiEnabled,
		fetchAIEnablement,
		error,
	} = useIsAdminHubAIEnabled(adminHubAiProductName);

	useEffect(() => {
		fetchAIEnablement();
	}, [fetchAIEnablement]);

	// Boolean constructor used as it can be null
	return !error && Boolean(isAiEnabled);
};
